import React from 'react';
import { Box, Flex, Grid, Badge, Text, useColorMode } from '@chakra-ui/react';
import moment from 'moment';

import { UserDeviceData } from '../query';

interface DevicesProps {
  devices: UserDeviceData[];
}

const Devices: React.FC<DevicesProps> = ({ devices }) => {
  const { colorMode } = useColorMode();
  const headerBg = colorMode === 'light' ? 'gray.100' : 'gray.700';

  const sorted = [...devices].sort(
    (a, b) => moment(b.lastUsed).unix() - moment(a.lastUsed).unix(),
  );

  if (!devices || devices.length === 0) {
    return (
      <Box borderLeftWidth="1px" borderRightWidth="1px" borderBottomWidth="1px" px="4" py="8">
        <Flex width="100%" height="200px" justifyContent="center" alignItems="center">
          <Text>Keine Geräte registriert.</Text>
        </Flex>
      </Box>
    );
  }

  return (
    <Box borderLeftWidth="1px" borderRightWidth="1px" borderBottomWidth="1px" px="4" py="8" overflowX="auto">
      <Grid width="100%" gridTemplateColumns="auto auto auto auto auto auto auto" minWidth="800px">
        <Box p="2" backgroundColor={headerBg} fontWeight="bold" fontSize="sm">
          Betriebssystem
        </Box>
        <Box p="2" backgroundColor={headerBg} fontWeight="bold" fontSize="sm">
          Modell
        </Box>
        <Box p="2" backgroundColor={headerBg} fontWeight="bold" fontSize="sm">
          App Version
        </Box>
        <Box p="2" backgroundColor={headerBg} fontWeight="bold" fontSize="sm">
          Standort
        </Box>
        <Box p="2" backgroundColor={headerBg} fontWeight="bold" fontSize="sm">
          Zuletzt verwendet
        </Box>
        <Box p="2" backgroundColor={headerBg} fontWeight="bold" fontSize="sm">
          Erstmals gesehen
        </Box>
        <Box p="2" backgroundColor={headerBg} fontWeight="bold" fontSize="sm">
          Geräte-ID
        </Box>

        {sorted.map((device) => (
          <React.Fragment key={device.id}>
            <Box px="2" py="3" borderBottomWidth="1px" fontSize="sm">
              <Badge colorScheme={device.os?.toLowerCase().includes('ios') ? 'blue' : 'green'} mr="1">
                {device.os}
              </Badge>
              {device.osVersion}
            </Box>
            <Box px="2" py="3" borderBottomWidth="1px" fontSize="sm">
              {device.model}
            </Box>
            <Box px="2" py="3" borderBottomWidth="1px" fontSize="sm">
              {device.appVersion || '–'}
            </Box>
            <Box px="2" py="3" borderBottomWidth="1px" fontSize="sm">
              {device.lastLocationName || '–'}
            </Box>
            <Box px="2" py="3" borderBottomWidth="1px" fontSize="sm">
              {moment(device.lastUsed).format('DD.MM.YYYY, HH:mm')}
            </Box>
            <Box px="2" py="3" borderBottomWidth="1px" fontSize="sm">
              {moment(device.createdAt).format('DD.MM.YYYY, HH:mm')}
            </Box>
            <Box px="2" py="3" borderBottomWidth="1px" fontSize="xs" color="gray.500" wordBreak="break-all">
              {device.deviceId}
            </Box>
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
};

export default Devices;
